import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PageShellComponent } from '../../_components/page-shell/page-shell.component';

@Component({
  selector: 'app-help',
  templateUrl: './help.component.html',
  styleUrls: ['./help.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PageShellComponent]
})
export class HelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
